import { render, staticRenderFns } from "./document_attached.vue?vue&type=template&id=7738ef56&"
import script from "./document_attached.vue?vue&type=script&lang=js&"
export * from "./document_attached.vue?vue&type=script&lang=js&"
import style0 from "./document_attached.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports